import { Pipe, PipeTransform } from '@angular/core';
@Pipe({name: 'filter'})

export class FilterPipe implements PipeTransform {

    transform(list: any[], key: string, value: any): any {
        return list.filter(i => (value) ?  !!(i[key]) : !(i[key]));
    }
}